import { motion, AnimatePresence } from "framer-motion";
import { Gift, Compass, MessageCircle, ShieldCheck, Users, LifeBuoy, X, ArrowRight } from "lucide-react";
import { useT } from "@/i18n";

export default function Onboarding({ onClose }) {
  const { t } = useT();
  const steps = [
    { icon: Gift, t: t("ob1_t"), d: t("ob1_d"), color: "var(--accent)", bg: "var(--accent-soft)" },
    { icon: Compass, t: t("ob2_t"), d: t("ob2_d"), color: "var(--primary)", bg: "var(--primary-soft)" },
    { icon: MessageCircle, t: t("ob3_t"), d: t("ob3_d"), color: "#0f3d5c", bg: "#e0f2fe" },
    { icon: ShieldCheck, t: t("ob4_t"), d: t("ob4_d"), color: "#d9532f", bg: "#fdeae5" },
    { icon: Users, t: t("ob5_t"), d: t("ob5_d"), color: "#059669", bg: "#d1fae5" },
    { icon: LifeBuoy, t: t("ob6_t"), d: t("ob6_d"), color: "#92600a", bg: "#f7ecd2" },
  ];

  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" data-testid="onboarding-modal">
        <motion.div initial={{ scale: 0.94, opacity: 0, y: 20 }} animate={{ scale: 1, opacity: 1, y: 0 }} exit={{ scale: 0.96, opacity: 0 }}
          transition={{ type: "spring", damping: 26, stiffness: 280 }}
          className="w-full max-w-lg bg-white rounded-3xl overflow-hidden card-shadow max-h-[92vh] overflow-y-auto">
          <div className="relative p-7 pb-6 grain" style={{ background: "var(--primary)", color: "var(--on-primary)" }}>
            <button onClick={onClose} data-testid="onboarding-close" className="absolute right-4 top-4 text-white/70 hover:text-white"><X className="w-5 h-5" /></button>
            <img src="/logo.png" alt="Deuro" className="w-14 h-14 rounded-2xl mb-3" />
            <h2 className="font-head text-2xl font-extrabold tracking-tight">{t("ob_welcome_title")}</h2>
            <p className="text-[#c9d3cb] mt-1">{t("ob_welcome_sub")}</p>
          </div>

          <div className="p-6 space-y-4">
            {steps.map((s, i) => (
              <motion.div key={i} initial={{ opacity: 0, x: -12 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.1 + i * 0.08 }}
                className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0" style={{ background: s.bg }}>
                  <s.icon className="w-5.5 h-5.5" style={{ color: s.color, width: 22, height: 22 }} />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-mono text-xs font-bold text-[#d97706]">{i + 1}</span>
                    <h3 className="font-head font-bold text-[17px]">{s.t}</h3>
                  </div>
                  <p className="text-sm text-[#5f6b62] mt-0.5 leading-relaxed">{s.d}</p>
                </div>
              </motion.div>
            ))}
            <button onClick={onClose} data-testid="onboarding-start-btn"
              className="w-full flex items-center justify-center gap-2 py-3.5 mt-2 rounded-xl bg-[#d97706] text-white font-semibold hover:bg-[#c26806] active:scale-[0.99] transition-all">
              {t("ob_start")} <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
